<template>
  <div style="display:none;">
    <hshead :title="curRole=='store'?'店铺菜单':'摄影师菜单'" BgColor="#fff"></hshead>
    <div class="router-ul" v-if="curRole=='store'">
      <p style="font-size:0.4em;">当前登录角色：{{curRole}}</p>
      <router-link to="/user/login">登录</router-link>
      <router-link to="/user/modifyPwd">修改密码</router-link>
      <router-link to="/user/userInfo">用户信息</router-link>
      <br>
      <router-link to="/store/grapher">店铺摄影师</router-link>
      <a @click="showTip('请从“店铺摄影师”进入')">约拍城市审核</a>
      <br>
      <router-link to="/store/missionHall">任务中心</router-link>
      <router-link to="/store/other">更多</router-link>
      <br>
      <router-link to="/store/order">订单列表</router-link>
      <a @click="showTip('请从“订单列表”进入')">订单详情</a>
      <br>
      <router-link to="/store/Product">产品列表</router-link>
      <a @click="showTip('请从“产品列表”进入')">套餐列表</a>
      <br>
      <router-link to="/store/shopCustomers">店铺客户</router-link>
      <router-link to="/store/income">店铺收益</router-link>
      <router-link to="/store/storeInfo">店铺信息</router-link>
    </div>
    <div class="router-ul" v-if="curRole=='grapher'">
      <p style="font-size:0.4em;">当前登录角色：{{curRole}}</p>
      <router-link to="/user/login">登录</router-link>
      <router-link to="/user/modifyPwd">修改密码</router-link>
      <router-link to="/user/userInfo">用户信息</router-link>
      <br>
      <router-link to="/grapher/missionHall">任务大厅</router-link>
      <router-link to="/grapher/shootCitys">约拍城市</router-link>
      <br>
      <router-link to="/grapher/center">摄影师中心</router-link>
      <router-link to="/grapher/income">摄影师收益</router-link>
      <br>
      <router-link to="/grapher/order">订单列表</router-link>
      <a @click="showTip('请从“订单列表”进入')">订单详情</a>
    </div>
  </div>
</template>

<script>

import hshead from "@/components/common/hshead";
import { Notify } from "vant";
import { getCurRole } from "@/utils/auth"; // get token from cookie

export default {
  name: "index",
  data() {
    return{
      curRole: '',
    }
  },
  created() {
    const role = getCurRole()
    console.info('role', role)
    this.curRole = role
    // 根据登录角色 跳转到对应的默认页
    if(this.curRole == 'store')
      window.location.href = '/Store/Other'
    else if(this.curRole == 'grapher')
      window.location.href = '/Grapher/Center'
  },
  methods: {
    showTip(msg) {
      Notify({background: '#1989fa', message: msg});
    },
  },
  components:{
      hshead
  }
};
</script>

<style lang="less" scoped>
.router-ul{
  padding: 0.3rem;
  a{
    font-size: 0.4rem;
    color: blue;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/user/index.vue